var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M3.75 6.5A2.75 2.75 0 0 1 6.5 3.75h11a2.75 2.75 0 0 1 2.75 2.75v11a2.75 2.75 0 0 1-2.75 2.75h-11a2.75 2.75 0 0 1-2.75-2.75zM6.5 5.25c-.69 0-1.25.56-1.25 1.25v8.399l3.17-3.874a.75.75 0 0 1 1.166.006l3.476 4.346 1.908-1.907a.75.75 0 0 1 1.09.032l2.69 3.025V6.5c0-.69-.56-1.25-1.25-1.25zM5.25 17.5v-.232l3.743-4.576 3.421 4.276a.75.75 0 0 0 1.116.062l1.938-1.937 2.92 3.286c-.226.229-.54.371-.888.371h-11c-.69 0-1.25-.56-1.25-1.25m8.5-8.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M15 6.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5",
    clipRule: "evenodd"
  })));
};
export default SvgImage;